import React from "react"
import {Row, Col} from "react-bootstrap"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

interface Props {
  total: number
  currency: string
  paid?: boolean
  isCents?: boolean
}

const Total: React.FC<Props> = ({total, paid = false, currency, isCents = true}) => (
  <Row>
    <Col xs={12}>
      <Flex justifyContent="space-between">
        <strong>
          <FormattedMessage id={paid ? "perks.components.orderSummary.total.paid" : "perks.components.orderSummary.total.toPay"} />
        </strong>
        <Label large>
          <FormattedCurrency isCents={isCents} currency={currency} value={total} />
        </Label>
      </Flex>
    </Col>
  </Row>
)

export default Total
